import {
    bookableProductTemplateFactory,
    bookableProductTemplateZodObject,
} from "@@/shared/products/templates/product-templates/bookable.product-template";
import {
    buyableProductTemplateFactory,
    buyableProductTemplateZodObject,
} from "@@/shared/products/templates/product-templates/buyable.product-template";
import {
    voucherProductTemplateFactory,
    voucherProductTemplateZodObject,
} from "@@/shared/products/templates/product-templates/voucher.product-template";
import { z } from "zod";

const productTemplateZodUnion = z.union([
    bookableProductTemplateZodObject,
    buyableProductTemplateZodObject,
    voucherProductTemplateZodObject,
]);

type ProductTemplate = z.infer<typeof productTemplateZodUnion>;
type ProductTemplateTypes = ProductTemplate["_type"];

const productTemplateFactory = {
    bookable: bookableProductTemplateFactory,
    buyable: buyableProductTemplateFactory,
    voucher: voucherProductTemplateFactory,
};

export { productTemplateFactory, productTemplateZodUnion };
export type { ProductTemplate, ProductTemplateTypes };
